import _ from "lodash";
import React from "react";
import classes from "./AssessmentToolAccordionTable.scss";
import CriteriaRating from "UIComponents/CriteriaRating";
import AIJustification from "UIComponents/AIJustification";
import I18nHOC from "UIComponents/I18nHOC";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { InformationOutlined } from "@toddle-edu/ds-icons";

import classNames from "classnames";
import { connect } from "react-redux";
import {
  RUBRIC,
  CHECKLIST,
  MYP_OBJECTIVE_RUBRIC,
  MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC,
} from "Constants/stringConstants";
import { compose } from "lib/apolloClient";
import {
  deletePypElementRating,
  createIbPypElementRating,
} from "AssessmentEvaluation/modules/AssessmentEvaluationModule";
import { colors } from "Constants";
import ConditionalWrapper from "Utils/ConditionalWrapper";

const styles = {
  tooltipContainerStyle: {
    width: "500px",
  },
  customSelectedStyle: {
    backgroundColor: colors.blue400,
  },
  containerStyle: {
    width: "max-content",
  },
  overlayInnerStyle: {
    maxWidth: "500px",
  },
  tooltipOverlayInnerStyle: {
    maxWidth: "161px",
  },
};

const iconBtnProp = { type: "plain" };

const Body = props => {
  const {
    isEvaluatedByStudent,
    toolEvaluationResponses,
    indicatorId,
    criterias,
    descriptors,
    isEvaluation,
    updateEvaluationCell,
    userType,
    toolType,
    isMYPRubric,
    isEvaluationEnable,
    showUpdatedDesign,
    isGeneratingAIResponse,
    onAcceptAIEvaluation,
    isAiEvaluationEnabled,
  } = props;

  const criteriaDescriptorContainer = classNames({
    [classes.criteriaDescriptorContainer]: true,
    [classes.criteriaDescriptorContainerOverflow]:
      _.size(criterias) > 4 && !isMYPRubric,
    [classes.mypCriteriaDescriptorContainer]: isMYPRubric,
  });

  const groupedToolEvaluationResponse = _.groupBy(
    toolEvaluationResponses,
    "creatorType"
  );

  const staffToolEvaluationResponses = _.get(
    groupedToolEvaluationResponse,
    "STAFF",
    []
  );

  const studentToolEvaluationResponses = _.get(
    groupedToolEvaluationResponse,
    "STUDENT",
    []
  );

  const aiToolEvaluationResponses = _.get(
    groupedToolEvaluationResponse,
    "AI",
    []
  );

  const onClickCell = ({
    criteria,
    descriptor,
    isTeacherSelected,
    isStudentSelected,
  }) => {
    let rowId = "";
    let columnId = "";

    switch (toolType) {
      case RUBRIC:
        {
          rowId = _.get(descriptor, "indicator.id");
          columnId =
            (userType == "staff" && isTeacherSelected) ||
            (userType == "student" && isStudentSelected)
              ? null
              : _.get(descriptor, "criteria.id");
        }
        break;
      case CHECKLIST:
        {
          rowId = indicatorId;
          columnId =
            (userType == "staff" && isTeacherSelected) ||
            (userType == "student" && isStudentSelected)
              ? null
              : _.get(criteria, "id");
        }
        break;
      case MYP_OBJECTIVE_RUBRIC:
      case MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC: {
        rowId = _.get(descriptor, "objective.id");
        columnId =
          (userType == "staff" && isTeacherSelected) ||
          (userType == "student" && isStudentSelected)
            ? null
            : _.get(descriptor, "achievementLevel.id");
      }
    }

    const aiSelectedRow = _.find(
      aiToolEvaluationResponses,
      response => response.rowId === rowId && !response.isDeleted
    );

    // if there is an AI response, then delete it and copy it to staff response
    const shouldDeleteAIResponse =
      isAiEvaluationEnabled &&
      userType === "staff" &&
      aiSelectedRow &&
      columnId !== null;

    if (isEvaluation && rowId) {
      updateEvaluationCell({
        rowId,
        columnId,
        isDeleteAiRatings: shouldDeleteAIResponse,
        isSelected: isTeacherSelected,
      });
    }

    // copy ai response to staff response and delete ai response
    if (shouldDeleteAIResponse) {
      onAcceptAIEvaluation({
        rowId,
        columnId,
      });
    }
  };

  return _.map(criterias, criteria => {
    const { id, label } = criteria || {};

    let descriptor = _.find(
      descriptors,
      des =>
        _.get(des, "indicator.id") == indicatorId &&
        _.get(des, "criteria.id") == id
    );

    switch (toolType) {
      case MYP_OBJECTIVE_RUBRIC:
      case MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC: {
        descriptor =
          _.find(descriptors, descriptor => {
            return (
              _.get(descriptor, "objective.id") == indicatorId &&
              _.get(descriptor, "achievementLevel.id") == id
            );
          }) || {};
      }
    }

    let isTeacherSelected = false;
    let isStudentSelected = false;
    let isAISelected = false;
    let tooltipContent = label;
    let tooltipCondition = _.size(label) >= 12;
    let tooltipPlacement = "top";

    switch (toolType) {
      case RUBRIC:
        {
          tooltipContent = (
            <div>
              <div className="text-label-s">{_.trim(label)}</div>
              <div className="text-body-s">
                {_.get(descriptor, "label", "")}
              </div>
            </div>
          );
          tooltipCondition = true;
          tooltipPlacement = "bottom";

          isTeacherSelected =
            _.findIndex(
              staffToolEvaluationResponses,
              response =>
                _.get(response, "rowId") == _.get(descriptor, "indicator.id") &&
                _.get(response, "columnId") == _.get(descriptor, "criteria.id")
            ) >= 0;

          isStudentSelected =
            _.findIndex(
              studentToolEvaluationResponses,
              response =>
                _.get(response, "rowId") == _.get(descriptor, "indicator.id") &&
                _.get(response, "columnId") == _.get(descriptor, "criteria.id")
            ) >= 0 && isEvaluatedByStudent;

          isAISelected =
            _.findIndex(
              aiToolEvaluationResponses,
              response =>
                _.get(response, "rowId") == _.get(descriptor, "indicator.id") &&
                _.get(response, "columnId") ==
                  _.get(descriptor, "criteria.id") &&
                _.get(response, "isDeleted") === false
            ) >= 0 && userType === "staff";
        }
        break;
      case CHECKLIST:
        {
          isTeacherSelected =
            _.findIndex(
              staffToolEvaluationResponses,
              response =>
                _.get(response, "rowId") == indicatorId &&
                _.get(response, "columnId") == id
            ) >= 0;

          isStudentSelected =
            _.findIndex(
              studentToolEvaluationResponses,
              response =>
                _.get(response, "rowId") == indicatorId &&
                _.get(response, "columnId") == id
            ) >= 0 && isEvaluatedByStudent;

          isAISelected =
            _.findIndex(
              aiToolEvaluationResponses,
              response =>
                _.get(response, "rowId") == indicatorId &&
                _.get(response, "columnId") == id &&
                _.get(response, "isDeleted") === false
            ) >= 0 && userType === "staff";
        }
        break;
      case MYP_OBJECTIVE_RUBRIC:
      case MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC: {
        isTeacherSelected =
          _.findIndex(
            staffToolEvaluationResponses,
            response =>
              _.get(response, "rowId") == indicatorId &&
              _.get(response, "columnId") == id
          ) >= 0;

        isStudentSelected =
          _.findIndex(
            studentToolEvaluationResponses,
            response =>
              _.get(response, "rowId") == indicatorId &&
              _.get(response, "columnId") == id
          ) >= 0 && isEvaluatedByStudent;
        isAISelected =
          _.findIndex(
            aiToolEvaluationResponses,
            response =>
              _.get(response, "rowId") == indicatorId &&
              _.get(response, "columnId") == id &&
              _.get(response, "isDeleted") === false
          ) >= 0 && userType === "staff";
      }
    }

    const criteriaContainerClass = classNames({
      ["text-body-2"]: !showUpdatedDesign,
      [classes.criteriaContainer]: true,
      [classes.studentSelection]: isStudentSelected && !isAISelected,
      [classes.teacherSelection]:
        !showUpdatedDesign &&
        (isAiEvaluationEnabled
          ? isTeacherSelected && !isAISelected
          : isTeacherSelected),
      [classes.cursorNotAllowed]: !isEvaluationEnable,
      [classes.criteriaContainerV2]: showUpdatedDesign,
      ["text-body-s"]: showUpdatedDesign,
      [classes.teacherSelectionV2]:
        showUpdatedDesign &&
        (isAiEvaluationEnabled
          ? isTeacherSelected && !isAISelected
          : isTeacherSelected),
      [classes.aiSelection]: isAISelected,
    });

    const handleClickEvaluation = () => {
      if (isEvaluationEnable) {
        onClickCell({
          criteria,
          descriptor,
          isTeacherSelected,
          isStudentSelected,
        });
      }
    };

    return (
      <div className={criteriaDescriptorContainer} key={id}>
        {isGeneratingAIResponse ? (
          <SkeletonLoader width={"100%"} height={46} />
        ) : (
          <div
            className={criteriaContainerClass}
            tabIndex={isEvaluationEnable ? 0 : null}
            onClick={handleClickEvaluation}
            onKeyDown={e =>
              (e.key === "Enter" || e.key === " ") && handleClickEvaluation()
            }
          >
            <ConditionalWrapper
              type={"wrapperAsElement"}
              condition={tooltipCondition}
              wrapper={
                <Tooltip
                  tooltip={tooltipContent}
                  placement={tooltipPlacement}
                  dsVersion={showUpdatedDesign ? "2.0" : "1.0"}
                  showArrow={true}
                  overlayInnerStyle={styles.tooltipOverlayInnerStyle}
                />
              }
            >
              <div className={classes.criteria}>{_.trim(label)}</div>
            </ConditionalWrapper>

            {isTeacherSelected &&
            (isAiEvaluationEnabled ? !isAISelected : true) ? (
              <div className={classes.teacherDot} />
            ) : isAISelected ? (
              <div className={classes.aiDot} />
            ) : null}

            {isStudentSelected ? (
              <div
                className={classes.studentDot}
                style={{
                  right: isTeacherSelected || isAISelected ? "16px" : "6px",
                }}
              />
            ) : null}
          </div>
        )}
      </div>
    );
  });
};

const AssessmentToolAccordionTable = props => {
  const {
    t,
    assessmentTool,
    academicCriteriaValues,
    isEvaluationEnable = true,
    showRatingContainerInViewMode,
    deletePypElementRating,
    studentIds,
    studentId,
    parentId,
    isEvaluated,
    criteriaSet,
    criteriaSetId,
    ibPypElementId,
    selectedCriteria,
    ibPYPElementRatings,
    parentType,
    nonLeafObjective,
    toolType,
    userType,
    academicTermId,
    sourceFrom,
    showUpdatedDesign = false,
    toolEvaluationResponses,
    isAiEvaluationEnabled,
    onAcceptAIEvaluation,
    createIbPypElementRating,
    isGeneratingAIResponse,
    showUpdatedDesignForAIGrading,
  } = props;

  const { criterias = [], indicators = [], descriptors = [] } =
    assessmentTool || {};

  const handleCriteriaClick = criteriaId => {
    const isDeleteAiRatings =
      isAiEvaluationEnabled && selectedCriteria?.creatorType === "AI";

    if (isDeleteAiRatings) {
      onAcceptAIEvaluation({
        ibPypElementId,
        academicTermId,
        academicCriteriaValueId: criteriaId,
        academicCriteriaSetId: criteriaSetId,
      });
    }

    if (
      selectedCriteria &&
      _.get(selectedCriteria, "academicCriteriaValue.id", "") === criteriaId &&
      !isDeleteAiRatings
    ) {
      deletePypElementRating({
        studentIds,
        studentId,
        parentId,
        parentType,
        type: "MYP_OBJECTIVES",
        id: ibPypElementId,
        setId: criteriaSetId,
        academicTermId,
      });
    } else {
      createIbPypElementRating({
        parentId,
        parentType,
        studentId,
        studentIds,
        criteriaValue: criteriaId,
        type: "MYP_OBJECTIVES",
        id: ibPypElementId,
        setId: criteriaSetId,
        isDeleteAiRatings,
        isPublished: isEvaluated,
        criteriaSet,
        academicCriteriaValue: _.find(academicCriteriaValues, {
          id: criteriaId,
        }),
        academicTermId,
        sourceFrom,
      });
    }
  };

  const isMYPRubric = _.includes(
    [MYP_OBJECTIVE_RUBRIC, MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC],
    toolType
  );

  const aiPYPElementRating = _.find(ibPYPElementRatings, {
    ibPYPElementId: ibPypElementId,
    creatorType: "AI",
  });

  const justificationMessage = _.get(
    aiPYPElementRating,
    "evaluationJustification.message",
    ""
  );

  const criteriaLabel = _.split(nonLeafObjective?.label, ":")?.[0];

  const aiEvaluationLabel = `${criteriaLabel}: ${_.get(
    aiPYPElementRating,
    "academicCriteriaValue.label",
    ""
  )}/${_.size(academicCriteriaValues) - 1}`;

  const isAISelectedCriteria =
    isAiEvaluationEnabled &&
    selectedCriteria?.creatorType === "AI" &&
    !selectedCriteria?.isDeleted;

  const criteriaRatingContainerClass = classNames({
    [classes.criteriaRatingContainer]: true,
    [classes.cursorNotAllowed]: !isEvaluationEnable,
  });

  const innerContainerClasses = classNames({
    [classes.innerContainer]: true,
    [classes.innerContainerV2]: showUpdatedDesign,
    [classes.aiGradingInnerContainer]: isAiEvaluationEnabled,
    [classes.borderBottom]: !isMYPRubric && showUpdatedDesignForAIGrading,
  });

  const containerClasses = classNames({
    [classes.container]: true,
    [classes.containerV2]: showUpdatedDesign || showUpdatedDesignForAIGrading,
    [classes.borderBottom]: isMYPRubric && showUpdatedDesignForAIGrading,
  });

  const ratingContainer = classNames({
    [classes.ratingContainer]: true,
    [classes.ratingContainerV2]: isAiEvaluationEnabled,
  });

  let hasAIToolResponse = false;

  return (
    <div className={containerClasses}>
      {_.map(indicators, indicator => {
        const { id, label } = indicator || {};

        const groupedToolEvaluationResponse = _.groupBy(
          toolEvaluationResponses,
          "creatorType"
        );

        const aiToolEvaluationResponses = _.filter(
          _.get(groupedToolEvaluationResponse, "AI"),
          ({ rowId }) => rowId === id
        );

        const evaluationJustifications = _.compact(
          _.map(aiToolEvaluationResponses, "evaluationJustification.message")
        );

        hasAIToolResponse =
          hasAIToolResponse ||
          !_.isEmpty(_.filter(aiToolEvaluationResponses, { isDeleted: false }));

        const bodyContainerClass = classNames({
          [classes.bodyContainer]: true,
          [classes.bodyContainerOverflow]:
            _.size(criterias) > 4 && !isMYPRubric,
          [classes.mypBodyContainer]: isMYPRubric,
          ["text-body-2"]: true,
        });

        const indicatorClass = classNames({
          [classes.indicator]: true,
          [classes.indicatorWithIcon]: !_.isEmpty(evaluationJustifications),
          ["text-body-2"]: !isAiEvaluationEnabled,
          ["text-label"]: isAiEvaluationEnabled && !isMYPRubric,
          ["text-body"]: isAiEvaluationEnabled && isMYPRubric,
          [classes.cursorNotAllowed]: !isEvaluationEnable,
        });

        const renderJustification = () => {
          const isMYPObjectiveOrInterdisciplinaryCriteria = _.includes(
            [MYP_OBJECTIVE_RUBRIC, MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC],
            toolType
          );

          // we are showing justification for MYP and IDU on best fit rating
          const shouldRenderJustification =
            isAiEvaluationEnabled && !isMYPObjectiveOrInterdisciplinaryCriteria;

          if (!shouldRenderJustification) {
            return null;
          }

          const aiResponse = _.first(aiToolEvaluationResponses);

          const aiEvaluationLabel = _.find(criterias, {
            id: aiResponse?.columnId,
          })?.label;

          return (
            <AIJustification
              justifications={evaluationJustifications}
              isAIGeneratingResponse={isGeneratingAIResponse}
              aiEvaluationLabel={aiEvaluationLabel}
              isAIResponseAccepted={aiResponse?.isDeleted}
            />
          );
        };

        return (
          <div key={id} className={innerContainerClasses}>
            {label ? <div className={indicatorClass}>{label}</div> : null}
            <div className={bodyContainerClass}>
              <Body
                indicatorId={id}
                criterias={criterias}
                descriptors={descriptors}
                isMYPRubric={isMYPRubric}
                isGeneratingAIResponse={isGeneratingAIResponse}
                {...props}
              />
            </div>

            {!_.isEmpty(evaluationJustifications)
              ? isAiEvaluationEnabled
                ? renderJustification()
                : null
              : null}
          </div>
        );
      })}

      {!_.isEmpty(academicCriteriaValues) ? (
        <div className={ratingContainer}>
          <div className={classes.bestFitRatingText}>
            {t("unitPlan:best_fit_rating_for_text_normal", {
              label: _.get(nonLeafObjective, "label", ""),
            })}

            <Tooltip
              tooltip={t(
                userType === "staff"
                  ? "classRoom:rubric_rating_tooltip"
                  : "classRoom:rubric_rating_tooltip_for_reader"
              )}
              overlayInnerStyle={styles.overlayInnerStyle}
              placement={"left"}
              dsVersion={showUpdatedDesign ? "2.0" : "1.0"}
              showArrow={true}
            >
              <IconButton
                size={showUpdatedDesign ? "small" : "x-small"}
                icon={<InformationOutlined />}
                dsVersion={showUpdatedDesign ? "2.0" : "1.0"}
                variant={showUpdatedDesign ? "neutral" : "plain"}
                {...(showUpdatedDesign ? iconBtnProp : {})}
              />
            </Tooltip>
          </div>
          <div className={criteriaRatingContainerClass}>
            {isGeneratingAIResponse ? (
              <div className={classes.skeletonContainer}>
                {_.times(_.size(academicCriteriaValues), index => {
                  return <SkeletonLoader key={index} width={44} height={32} />;
                })}
              </div>
            ) : (
              <CriteriaRating
                shouldUpdateOnValueChnage={true}
                isEvaluation={isEvaluationEnable}
                options={academicCriteriaValues}
                value={_.get(selectedCriteria, "academicCriteriaValue.id", "")}
                isViewMode={showRatingContainerInViewMode}
                onCriteriaClick={handleCriteriaClick}
                customSelectedStyle={styles.customSelectedStyle}
                containerStyle={styles.containerStyle}
                timeOut={0}
                customRatingElementClass={classes.customRatingElementClass}
                isAISelectedCriteria={isAISelectedCriteria}
                isGeneratingAIResponse={isGeneratingAIResponse}
                customSelectedRatingElement={
                  isAISelectedCriteria
                    ? classes.customAISelectedRatingElement
                    : classes.customSelectedRatingElement
                }
              />
            )}
          </div>
          {isAiEvaluationEnabled && justificationMessage ? (
            <AIJustification
              justifications={[justificationMessage]}
              aiEvaluationLabel={aiEvaluationLabel}
              isAIResponseAccepted={
                aiPYPElementRating?.isDeleted && !hasAIToolResponse
              }
              isAIGeneratingResponse={isGeneratingAIResponse}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    userType: _.get(state, "login.userInfo.user_type", ""),
  };
};

const mapActionCreators = {
  createIbPypElementRating,
  deletePypElementRating,
};

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(mapStateToProps, mapActionCreators)
)(AssessmentToolAccordionTable);
